import React from "react";
import Logo from '../assets/images/logo.png';
import {
  Twitter,
  Headset,
  Mail,
  Phone,
  Instagram,
  Youtube,
  Facebook,
  MapPin,
  Send
} from "lucide-react";

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const socialLinks = [
    { icon: Twitter, href: "https://x.com/@creartcloud", label: "Twitter" },
    { icon: Instagram, href: "https://www.instagram.com/creartcloud/", label: "Instagram" },
    { icon: Youtube, href: "https://www.youtube.com/@creartcloud", label: "YouTube" },
    { icon: Facebook, href: "https://facebook.com/creartcloud", label: "Facebook" },
  ];

  return (
    <footer className="bg-gray-950 text-gray-300 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 py-12">
        {/* Üst Kısım */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6 pb-8 border-b border-gray-800">
          <div className="flex items-center gap-4">
            <img src={Logo} alt="Creart Cloud" className="h-10 w-auto" />
            <span className="text-sm text-gray-500">© 2024 Creart Cloud</span>
          </div>

          <div className="flex items-center gap-3">
            {socialLinks.map((social) => (
              <a
                key={social.label}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-lg bg-gray-800/50 text-gray-400 hover:text-white hover:bg-gray-700 transition-all"
              >
                <social.icon size={18} />
              </a>
            ))}
          </div>
        </div>

        {/* Ana Menü */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 py-12">
          <div>
            <h3 className="text-white font-semibold mb-4">Sunucu</h3>
            <ul className="space-y-3">
              <li><a href="/virtual-server" className="text-gray-400 hover:text-white text-sm">Sanal Sunucu (VDS)</a></li>
              <li><a href="/ryzen-server" className="text-gray-400 hover:text-white text-sm">Ryzen VDS</a></li>
              <li><a href="/dedicated-server" className="text-gray-400 hover:text-white text-sm">Dedicated Sunucu</a></li>
              <li><a href="/gpu-server" className="text-gray-400 hover:text-white text-sm">GPU Sunucu</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Hosting</h3>
            <ul className="space-y-3">
              <li><a href="/web-hosting" className="text-gray-400 hover:text-white text-sm">Web Hosting</a></li>
              <li><a href="/plesk-hosting" className="text-gray-400 hover:text-white text-sm">Plesk Hosting</a></li>
              <li><a href="/reseller-hosting" className="text-gray-400 hover:text-white text-sm">Reseller Hosting</a></li>
              <li><a href="/wordpress-hosting" className="text-gray-400 hover:text-white text-sm">WordPress Hosting</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Veri Merkezi</h3>
            <ul className="space-y-3">
              <li><a href="/server-location" className="text-gray-400 hover:text-white text-sm">Sunucu Barındırma</a></li>
              <li><a href="/subnet-leasing" className="text-gray-400 hover:text-white text-sm">Subnet Kiralama</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Kurumsal</h3>
            <ul className="space-y-3">
              <li><a href="/about-us" className="text-gray-400 hover:text-white text-sm">Hakkımızda</a></li>
              <li><a href="/bank-information" className="text-gray-400 hover:text-white text-sm">Banka Bilgileri</a></li>
              <li><a href="/agreements" className="text-gray-400 hover:text-white text-sm">Sözleşmeler</a></li>
              <li><a href="/career" className="text-gray-400 hover:text-white text-sm">Kariyer</a></li>
            </ul>
          </div>
        </div>

        {/* İletişim */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 py-8">
          <a href="/support" className="flex items-center gap-3 text-gray-400 hover:text-white">
            <Headset size={18} />
            <div>
              <div className="text-sm font-medium text-white">7/24 Destek</div>
              <div className="text-xs text-gray-500">Canlı destek</div>
            </div>
          </a>
          <a href="mailto:info@creartcloud.com" className="flex items-center gap-3 text-gray-400 hover:text-white">
            <Mail size={18} />
            <div>
              <div className="text-sm font-medium text-white">info@creartcloud.com</div>
              <div className="text-xs text-gray-500">E-posta</div>
            </div>
          </a>
          <a href="mailto:abuse@creartcloud.com" className="flex items-center gap-3 text-gray-400 hover:text-white">
            <Send size={18} />
            <div>
              <div className="text-sm font-medium text-white">abuse@creartcloud.com</div>
              <div className="text-xs text-gray-500">Kötüye kullanım</div>
            </div>
          </a>
          <a href="https://wa.me/447821397716" className="flex items-center gap-3 text-gray-400 hover:text-white">
            <Phone size={18} />
            <div>
              <div className="text-sm font-medium text-white">+44 7821 397716</div>
              <div className="text-xs text-gray-500">Telefon</div>
            </div>
          </a>
          <a href="https://maps.google.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-gray-400 hover:text-white col-span-2 md:col-span-4">
            <MapPin size={18} />
            <div>
              <div className="text-sm font-medium text-white">İstanbul, Türkiye</div>
              <div className="text-xs text-gray-500">Merkez ofis</div>
            </div>
          </a>
        </div>
        {/* Alt Kısım */}
        <div className="pt-8 mt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-gray-500">
          <div className="flex flex-col md:flex-row items-center gap-3 md:gap-4 text-center md:text-left">
            <span>
              Creart Cloud altyapısını{" "}
              <a
                href="https://www.netlack.com"
                target="_blank"
                rel="noopener noreferrer"
                title="Netlack Bilişim ve Hosting Hizmetleri"
                className="text-white/80 hover:text-white font-semibold hover:underline underline-offset-4 transition-all duration-300"
              >
                Netlack Bilişim & Hosting
              </a>{" "}
              alıyordur.
            </span>
            <span className="hidden md:inline text-white/20">•</span>
            <span className="text-gray-400">BTK Yetkili Sağlayıcı</span>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-3 md:gap-4">
            <a
              href="/agreements"
              className="hover:text-white transition-colors duration-300"
            >
              Gizlilik Politikası
            </a>
            <span className="text-white/20">•</span>
            <a
              href="/agreements"
              className="hover:text-white transition-colors duration-300"
            >
              Kullanım Koşulları
            </a>
            <span className="text-white/20">•</span>
            <button
              onClick={scrollToTop}
              className="hover:text-white transition-colors duration-300"
            >
              Yukarı Çık ↑
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}